<template>
    <div class="admin-requests-wrapper">
        <AdminYearFilter
            title="Employee Leave Requests"
            :all-employees="employeeList"
            @user-changed="handleOnEmployeeChanged"
            @date-change="handleDateChange"
        />
        <AdminLeaveRequestList
            :requests-data-list="requestList"
            :is-loading="isLoading"
            :total-count="totalCount"
            :current-page="currentPage"
            :total-per-page="limit"
            @reload="handleReload"
            @on-page-change="handleOnPageChanged"
            @on-process-request="handleLeaveRequest"
        />
    </div>
</template>

<script>
import { getAdminPaginatedRequestsByUser, requestProcess, requestLeaveProcess } from '@/services/requests.services';
import { getUsers } from '@/services/users.services';
import moment from 'moment/moment';
import { checkIfFirstAttendancePeriod, endOfDate, startOfDate } from '/utility/helper';
import AdminYearFilter from '@/components/Requests/Admin/AdminYearFilter.vue';
import { yearRange } from '@/components/Requests/Dev/shared/years';
import AdminLeaveRequestList from '@/components/Requests/Admin/Leave/LeaveRequest/AdminLeaveRequestList.vue';
import { adminCancelLeaveDaysV2 } from '@/services/requests.services';

export default {
    components: { AdminLeaveRequestList, AdminYearFilter },
    props: {
        selectedType: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            requestList: [],
            // No status filter in the UI anymore
            selectedStatus: null,
            selectedDates: null,
            selectedUser: this.$route.query.user,
            currentPage: 1,
            totalCount: null,
            isFilterClick: false,
            totalPerPage: 5,
            totalPages: 1,
            selectedFilter: 'createdAt',
            limit: 10,
            employeeList: [],
        };
    },
    created() {
        // if (!this.selectedDates) {
        //
        // }
        // Start on the current year; AdminYearFilter emits it on mount
        const { from, to } = yearRange(moment().year());
        this.selectedDates = { from: startOfDate(from), to: endOfDate(to) };
        // if (this.$route.query.status) {
        //     this.handleOnStatusChanged(this.$route.query.status);
        // }
        // if (this.$route.query.user) {
        //     this.handleGetTimeDisputeRequestsByUser(this.$route.query.user, this.selectedDates);
        // }
        // if (this.selectedType) {
        //     console.log('selectedType has value', this.selectedType);
        //     this.handleGetAllTimeDisputesRequests(this.selectedDates, this.selectedType);
        // }
        this.handleGetAllEmployees();
    },

    methods: {
        async handleDateChange(date) {
            if (date?.from) {
                this.selectedDates = { from: startOfDate(date.from), to: endOfDate(date.to) };
            } else {
                this.selectedDates = { from: '', to: '' };
            }
            this.refresh();
            await this.handleGetAllTimeDisputesRequests(this.selectedDates, this.selectedType);
        },
        checkPayPeriod() {
            const yearMonth = moment().format('yyyy-MM');
            console.log('checkIfDateFirstPeriod: ', checkIfFirstAttendancePeriod());
            const currentDate = moment().format('yyyy-MM-DD');
            return checkIfFirstAttendancePeriod()
                ? [`${yearMonth}-01`, `${yearMonth}-15`]
                : [`${yearMonth}-16`, moment(currentDate).endOf('month').format('yyyy-MM-DD')];
        },
        handleGetTimeDisputeRecordsByStatus(status, date, type = null) {
            this.isLoading = true;
            this.requestList = [];
            getAdminPaginatedRequestsByUser(
                {
                    status: status,
                    ...(this.selectedUser != null && { user: this.selectedUser }),
                    ...(date?.from && { [this.selectedFilter]: { $gte: date.from, $lte: date.to } }),
                    ...(type && { ...type }),
                },
                this.currentPage,
                this.limit
            )
                .then((res) => {
                    console.log('Result by Status: ', res);
                    if (res.data.data.length) {
                        this.isLoading = true;
                        this.totalCount = res.data.totalCount;
                        this.requestList =
                            this.selectedUser != null
                                ? res.data.data.filter((i) => i.user._id == this.selectedUser && i.status == status)
                                : res.data.data.filter((i) => i.status == status);
                    } else {
                        this.requestList = [];
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to get requests data by status and user');
                    this.requestList = [];
                    this.isLoading = false;
                });
        },
        handleOnStatusChanged(status) {
            this.selectedStatus = status;

            this.refresh();
            if (!this.selectedDates) {
                const actualDatePeriod = this.checkPayPeriod();
                this.selectedDates = {
                    from: startOfDate(actualDatePeriod[0]),
                    to: endOfDate(actualDatePeriod[1]),
                };
            }

            if (status) {
                this.handleGetTimeDisputeRecordsByStatus(status, this.selectedDates, this.type);
            } else if (this.selectedUser) {
                this.handleGetTimeDisputeRequestsByUser(this.selectedUser, this.selectedDates, this.type);
            } else {
                this.handleGetAllTimeDisputesRequests(this.selectedDates, this.type);
            }
        },
        handleReload() {
            if (this.selectedStatus) {
                this.handleGetTimeDisputeRecordsByStatus(this.selectedStatus, this.selectedDates, this.type);
            } else if (this.selectedUser) {
                this.handleGetTimeDisputeRequestsByUser(this.selectedUser, this.selectedDates, this.type);
            } else {
                this.handleGetAllTimeDisputesRequests(this.selectedDates, this.type);
            }
        },
        async filterChanged(data) {
            this.selectedFilter = data;
            await this.handleReload();
        },
        handleGetTimeDisputeRequestsByUser(userId, date) {
            this.isLoading = true;
            this.requestList = [];
            getAdminPaginatedRequestsByUser(
                {
                    user: userId,
                    ...(this.selectedStatus != null && { status: this.selectedStatus }),

                    ...(date?.from && { [this.selectedFilter]: { $gte: date.from, $lte: date.to } }),
                    ...(this.selectedType && { type: this.selectedType }),
                },
                this.currentPage,
                this.limit
            )
                .then((res) => {
                    console.log('Result by User: ', res);
                    if (res.data.data.length) {
                        this.totalCount = res.data.totalCount;
                        this.totalPages = res.data.totalPages;
                        this.totalPerPage = res?.data?.total || 5;
                        this.requestList =
                            this.selectedStatus != null
                                ? res.data.data.filter((i) => i.user._id == userId && i.status == this.selectedStatus)
                                : res.data.data.filter((i) => i.user._id == userId);
                    } else {
                        this.requestList = [];
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to get requests data by user');
                    this.requestList = [];
                    this.isLoading = false;
                });
        },
        handleGetAllEmployees() {
            this.isLoading = true;
            this.employeeList = [];
            getUsers()
                .then((res) => {
                    console.log('all-users: ', res);
                    if (res.data.length) {
                        let result = res.data.filter(
                            (x) => x.mainRole !== 'client' && x.mainRole !== 'admin' && x.isArchived === false
                        );

                        this.employeeList = result.map((i) => {
                            return {
                                value: i._id,
                                label: i.name,
                                name: i.name,
                                key: i._id,
                                _id: i._id,
                            };
                        });
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to get users');
                    this.isLoading = false;
                });
        },
        handleGetAllTimeDisputesRequests(date = null) {
            this.isLoading = true;
            this.requestList = [];
            getAdminPaginatedRequestsByUser(
                {
                    ...(this.selectedUser != null && { user: this.selectedUser }),
                    ...(this.selectedStatus != null && { status: this.selectedStatus }),

                    ...(date?.from && {
                        [this.selectedFilter]: { $gte: date.from, $lte: date.to },
                    }),
                    ...(this.selectedType && { type: this.selectedType }),
                },
                this.currentPage,
                this.limit
            )
                .then((res) => {
                    console.log('Result by All: ', res);
                    if (res.data.data.length) {
                        this.totalCount = res.data.totalCount;
                        this.totalPerPage = res?.data?.total || 5;
                        this.totalPages = res.data.totalPages;
                        this.requestList =
                            this.selectedUser != null && this.selectedStatus != null
                                ? res.data.data.filter(
                                      (i) => i.user._id == this.selectedUser && i.status == this.selectedStatus
                                  )
                                : res.data.data;
                    } else {
                        this.requestList = [];
                    }
                    this.isLoading = false;
                })
                .catch(() => {
                    this.$Message.error('Failed to get all requests data');
                    this.requestList = [];
                    this.isLoading = false;
                });
        },
        refresh() {
            this.currentPage = 1;
            this.totalPages = 1;
            this.totalCount = 1;
        },
        handleOnEmployeeChanged(user) {
            this.selectedUser = user;
            this.refresh();
            if (!this.selectedDates) {
                const actualDatePeriod = this.checkPayPeriod();
                this.selectedDates = {
                    from: startOfDate(actualDatePeriod[0]),
                    to: endOfDate(actualDatePeriod[1]),
                };
            }

            if (user) {
                this.handleGetTimeDisputeRequestsByUser(user, this.selectedDates, this.type);
            } else if (this.selectedStatus) {
                this.handleGetTimeDisputeRecordsByStatus(this.selectedStatus, this.selectedDates, this.type);
            } else {
                this.handleGetAllTimeDisputesRequests(this.selectedDates, this.type);
            }
        },
        handleRequest(id, status) {
            this.isLoading = true;
            const data = {
                id: id,
                status: status,
            };
            requestProcess(data)
                .then((res) => {
                    if (res && res.data.success) {
                        this.$Message.success(`Request has been ${status}`);
                        this.isLoading = false;
                        this.handleReload();
                        this.showModal = false;
                    }
                })
                .catch((err) => {
                    if (err.data.statusCode === 400 && err.data.message === 'request not found') {
                        this.$Message.error('Request not found');
                    } else if (err.data.statusCode === 403 && err.data.message === 'request already processed') {
                        this.$Message.error(
                            'You`ve already processed this request time dispute. Please do check it again.'
                        );
                    } else {
                        this.$Message.error('Failed to process request time dispute');
                    }
                    this.isLoading = false;
                });
        },

        handleLeaveRequest(id, status, leaveDate) {
            this.isLoading = true;
            const data = {
                id: id,
                status: status,
            };
            if (status === 'cancel') {
                // only the day of the clicked row is cancelled
                adminCancelLeaveDaysV2(id, { ...(leaveDate && { dates: [leaveDate] }) })
                    .then(() => {
                        this.$Message.success(`Request has been cancelled`);
                        this.isLoading = false;
                        this.handleReload();
                        this.showModal = false;
                    })
                    .catch((err) => {
                        console.log('err: ', err);
                        if (err.data.statusCode === 400 && err.data.message === 'request not found') {
                            this.$Message.error('Request not found');
                        } else if (err.data.statusCode === 403 && err.data.message === 'request already cancelled') {
                            this.$Message.error(
                                'You`ve already processed this request time dispute. Please do check it again.'
                            );
                        } else {
                            this.$Message.error('Failed to process request cancel leave');
                        }
                        this.isLoading = false;
                    });
            } else {
                requestLeaveProcess(data)
                    .then((res) => {
                        if (res && res.data.success) {
                            this.$Message.success(`Request has been ${status}`);
                            this.isLoading = false;
                            this.handleReload();
                            this.showModal = false;
                        }
                    })
                    .catch((err) => {
                        if (err.data.statusCode === 400 && err.data.message === 'request not found') {
                            this.$Message.error('Request not found');
                        } else if (err.data.statusCode === 403 && err.data.message === 'request already processed') {
                            this.$Message.error(
                                'You`ve already processed this request time dispute. Please do check it again.'
                            );
                        } else {
                            this.$Message.error('Failed to process request time dispute');
                        }
                        this.isLoading = false;
                    });
            }
        },
        handleOnPageChanged(page) {
            this.currentPage = page;
            if (this.selectedStatus) {
                this.handleGetTimeDisputeRecordsByStatus(this.selectedStatus, this.selectedDates, this.type);
            } else if (this.selectedUser) {
                this.handleGetTimeDisputeRequestsByUser(this.selectedUser, this.selectedDates, this.type);
            } else {
                this.handleGetAllTimeDisputesRequests(this.selectedDates, this.type);
            }
        },
    },
};
</script>
<style lang="scss">
.admin-requests-wrapper {
    .ivu-col {
        button {
            border-radius: 15px;
        }
    }
    .title-wrapper {
        display: block;

        .ivu-col {
            max-width: 100% !important;
        }
        .text-right {
            text-align: left;
            padding-top: 0 !important;
        }
    }
}
</style>
